import { render, staticRenderFns } from "./BillingReport.vue?vue&type=template&id=afe98d20&scoped=true"
import script from "./BillingReport.vue?vue&type=script&lang=js"
export * from "./BillingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe98d20",
  null
  
)

export default component.exports